module.exports = "button {\n  margin-left: 8px; }\n"